// extracted by mini-css-extract-plugin
export default {"checkbox":"CheckboxMark-module-e94b0e625f4ee803fc70"};